<template>

    <SubHeader title="Liste des points focaux" :breads="[{ name: 'Point Focal' }]" :action="{}" />
    <Modal>


        <div class="" v-if="!deleteIsLoading">
            <span>Voulez-vous vraiment <b class="text-danger">retirer</b> l'utilisateur <strong>{{
                    currentUser?.firstname }}</strong> des points focaux ?

            </span>
        </div>
        <div class="spinner-grow" role="status" v-else>
            <span class="visually-hidden">Loading...</span>
        </div>
        <template #btn>
            <span v-if="!deleteIsLoading">
                <button type="button" class="btn btn-danger" @click="deleteUser(currentUser?.id)">
                    <i class="bi bi-ban"></i>
                    Retirer
                </button>
            </span>
            <div class="spinner-grow" role="status" v-else>
                <span class="visually-hidden">Loading...</span>
            </div>


        </template>
    </Modal>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div class="row justify-content-between align-items-center flex-grow-1">
                        <div class="col-12 col-md">
                            <div class="d-flex justify-content-between align-items-center">
                                <router-link :to="{ name: 'AdminPointFocalAdd' }"
                                    class="btn btn-outline-primary btn-xs">
                                    <i class="bi bi-plus me-1"></i> Ajouter
                                </router-link>

                            </div>
                        </div>

                        <div class="col-auto">
                            <!-- Filter -->
                            <form>
                                <!-- Search -->
                                <div class="input-group input-group-merge input-group-flush">
                                    <div class="input-group-prepend input-group-text">
                                        <i class="bi-search"></i>
                                    </div>
                                    <input id="datatableWithSearchInput" type="search" class="form-control"
                                        placeholder="Search users" v-model="searchWord" aria-label="Search users">
                                </div>
                                <!-- End Search -->
                            </form>
                            <!-- End Filter -->
                        </div>
                    </div>
                </div>
                <div class="card-body datatable-custom position-relative">
                    <data-table :rows="items" :columns="cols" :loading="isLoading" :sortable="true" sortColumn="label"
                        sortDirection="asc" paginationInfo="De {0} à {1} sur un total de {2}" :search="searchWord"
                        noDataContent="Pas de resultat"
                        class="advanced-table whitespace-nowrap table table-borderless table-thead-bordered ">

                        <template #firstname="{ value }">
                            <span>
                                {{ value.lastname }} {{ value.firstname }}</span>
                        </template>

                        <template #roles="{ value }">
                            <span class='badge bg-soft-dark text-dark ' v-for="(role, i) in value.roles" :key="i">
                                {{ role.name }} </span>
                        </template>
                        <template #institution="{ value }">
                            <span class='badge bg-soft-dark text-dark '>
                                {{ value.institution.label }}</span>
                        </template>
                        <template #status="{ value }">
                            <span
                                :class='value.status ? "badge bg-soft-success text-success" : "badge bg-soft-danger text-danger"'
                                :key="i">{{ value.status ? 'Actif' : 'Désactiver' }}</span>
                        </template>
                        <template #action="{ value }">

                            <div class="d-flex">
                                <router-link :to="{ name: 'AdminPointFocalShow', params: { id: value.id } }"
                                    class="btn btn-outline-dark btn-xs" title="Voir la fiche">
                                    <i class="bi bi-eye"></i>
                                </router-link>
                                <button @click="showModalDelete(value)" class="btn btn-outline-danger btn-xs mx-1"
                                    title="Supprimer">
                                    <i class="bi bi-ban"></i>
                                </button>
                            </div>
                        </template>

                    </data-table>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import Modal from "@/widgets/Modal.vue";
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminUserProfileUser",
    components: {
        SubHeader,
        Modal
    },
    data() {
        return {
            cols: [
                { field: 'firstname', title: 'Identité' },
                { field: 'email', title: 'email' },
                { field: 'roles', title: 'Roles' },
                { field: 'institution', title: 'Institution' },
                { field: 'status', title: 'Status', width: '10px', headerClass: 'justify-center', cellClass: 'justify-center' },

                { field: 'action', title: 'Actions', sort: false, width: '10px', headerClass: 'justify-center', cellClass: 'justify-center' },
            ],
            searchWord: null,
            currentUser: null,
        }

    },
    computed: {
        ...mapFields("widget/modal", {
            toggleModal: "showMessage",

        }),
        ...mapFields("focal/list", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items"
        }),
        ...mapFields("focal/del", {
            deleteIsLoading: "isLoading",
            isDeleted: "isDeleted",
            deleteShowMessage: "showMessage",
            deleteMessage: "message",
            deleteItems: "items"
        }),
    },
    watch: {
        isDeleted(val) {
            if (val) {
                this.toggleModal = false;
                this.currentUser = null;
                this.getUsers()

            }
        }
    },
    methods: {
        ...mapActions({
            getUsers: "focal/list/getAll",
            resetDelete: "focal/del/resetData",
            deleteUser: "focal/del/del",
            reset: "focal/list/resetData",
        }),
        showModalDelete(user) {
            this.currentUser = user;
            this.toggleModal = true;

        }
    },
    mounted() {
        this.getUsers()
    },
    unmounted() {
        this.reset()
    }
}
</script>
